 import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
  import {MaterialUIControllerProvider} from "./Context/mui";
import App from "./App";
import './custom.css'
 import 'bootstrap/dist/css/bootstrap.css';
import 'react-toastify/dist/ReactToastify.css';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);


root.render(
    <BrowserRouter basename={baseUrl}>
        <MaterialUIControllerProvider>
            <App/>
        </MaterialUIControllerProvider>
    </BrowserRouter>);
 
 